import GYAxios from "./GYAxios";

/**
	 * Send emails to Project Manager / Asset Manager when users are exported to Keycloak
   * 'NEW' and 'UPDATE' operations will use different email template
   * and also send email to the users directly if they are newly created GY users
	 */
 export const sendUserExportedEmail = async (clientName, country, recipient, users, operationType) => {
  let sendEmailAPI;

  // User creation requestors
  const _recipient = {
    name: recipient.name,
    email: recipient.email
  }

  // Get exported users email
  const clientUsers = users.map((user) => user.email);

  // Options for API request
  const opts = {
    recipient: _recipient,
    client_name: clientName,
    client_users: clientUsers,
  };

  if(operationType === 'NEW') {
    sendEmailAPI = "/users/send_email/new_users_exported";
    opts.country = country;
  }
  if(operationType === 'UPDATE') {
    sendEmailAPI = "/users/send_email/existing_users_exported";
  }

  // Send confirmation email to requestors
  return GYAxios.post(sendEmailAPI, opts).then((res) =>
    console.log(res.data)
  );
};

export const sendUserExportedNotificationToIT = async (users, byUser) => {
  return GYAxios.post('/users/send_email/users_exported_to_keycloak_notify_IT', { users, byUser }).then((res) => console.log(res.data));
}

// Send email to IT Staffs when users are created or updated by Project Manager / Asset Manager
// 'NEW' and 'UPDATE' operations will use different email template
export const sendUserCreatedUpdatedEmail = async ({ clientId, clientName, country, sites, users, originalUsers, currentUser, operationType }) => {
  if(!users.length) { return }
  let sendEmailAPI = "/users/send_email/users_created_or_updated";
  const payload = { operationType, clientId, clientName, country, sites, users, originalUsers, currentUser };
  return GYAxios.post(sendEmailAPI, payload).then(res => {
    console.log(res.data);
  });
}

// This will send email when GY user is trying to create a new user with duplciated email
export const sendDuplicatedEmailNotification = (duplicatedEmail, currentUser) => {
  const userUsingForm = { name: currentUser.name, email: currentUser.email };
  const payload = {
    userUsingForm,
    duplicatedEmail
  };
  GYAxios.post('/users/send_email/user_email_already_exist', payload);
};